import CompLayout from "@/pcomponents/comp/layout/layout";
import StuStudyMapArea from "@/pages/comp/plan/study/study_map/common/stu_map/list";

function StuStudyMapListPage() {

  return (
    <CompLayout isConTitle={false}>
      <div className="con_wrap">
        <StuStudyMapArea></StuStudyMapArea>
      </div>
    </CompLayout>
  );
};
export default StuStudyMapListPage;